import gql from "graphql-tag";

export const ManifestPrintoutLayoutListingFragment = gql`
    fragment ManifestPrintoutLayoutListingFragment on ManifestPrintoutLayoutListing {
        layoutName
        layoutClass
        previewImageUrl
    }
`